import { useEffect, useState } from "react";

export interface RecentRecord {
  entity: "Lead" | "Deal" | "Account" | "Contact";
  id: string;
  label: string;
  sub?: string;
  to: string;
}

const KEY = "crm.recent.records";
const MAX = 10;
const EVENT = "crm:recent-changed";

export function readRecents(): RecentRecord[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v.filter((r) => r && r.id && r.to).slice(0, MAX) : [];
  } catch {
    return [];
  }
}

/** Puts a record at the top of the "recently viewed" list (kept in this browser only) */
export function addRecent(r: RecentRecord) {
  try {
    localStorage.setItem(KEY, JSON.stringify([r, ...readRecents().filter((x) => !(x.entity === r.entity && x.id === r.id))].slice(0, MAX)));
    window.dispatchEvent(new Event(EVENT));
  } catch {
    /* not remembered */
  }
}

export function useRecents() {
  const [items, setItems] = useState<RecentRecord[]>(readRecents);
  useEffect(() => {
    const on = () => setItems(readRecents());
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return items;
}
